var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 d-flex flex-column"},[_c('h4',{staticClass:"ml-2 text--disabled"},[_vm._v(_vm._s(_vm.title))]),_c('h3',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }